import React from "react"
import ReactDOM from "react-dom"
import {DateTime} from "luxon"

import DaysView from './DaysView.jsx'
import MonthsView from './MonthsView.jsx'
import YearsView from './YearsView.jsx'
import TimeView from './TimeView.jsx'
import {MC} from "../MC.js"

let viewModes = Object.freeze({
  YEARS: 'years',
  MONTHS: 'months',
  DAYS: 'days',
  TIME: 'time',
})

class Datetime extends React.Component {

  allowedSetTime = ['hour', 'minute', 'second', 'millisecond']
  componentProps = {
    fromProps: ['value', 'min', 'max'],
    fromState: ['viewDate', 'selectedDate', 'updateOn'],
    fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localLuxon', 'isValidDay']
  }
  viewComponents = { days: DaysView, months: MonthsView, years: YearsView, time: TimeView }

  constructor(props, context) {
    super(props, context)
    let state = this.getStateFromProps(props)
    state.open = !props.input
    state.currentView = props.dateFormat ? (props.viewMode || state.updateOn || viewModes.DAYS) : viewModes.TIME
    this.state = state
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, false)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, false)
  }

  parseDate(date, formats) {
    let parsedDate
    if (date && typeof date === 'string') {
      parsedDate = this.localLuxon(date, formats.datetime)
    } else if (date) {
      parsedDate = this.localLuxon(date)
    }
    if (parsedDate && !parsedDate.isValid) {
      parsedDate = null
    }
    return parsedDate
  }

  getStateFromProps(props) {
    let formats = this.getFormats(props)
    let date = props.value || props.defaultValue
    let selectedDate = this.parseDate(date, formats)
    let viewDate = this.parseDate(props.viewDate, formats)
    viewDate = selectedDate ? selectedDate.startOf('month') : viewDate ? viewDate.startOf('month') : this.localLuxon().startOf('month')
    let updateOn = this.getUpdateOn(formats)
    let inputValue
    if (selectedDate) {
      inputValue = selectedDate.toFormat(formats.datetime)
    } else if (!date.isValid) {
      inputValue = date || ''
    }
    return {
      updateOn: updateOn,
      inputFormat: formats.datetime,
      viewDate: viewDate,
      selectedDate: selectedDate,
      inputValue: inputValue
    }
  }

  getUpdateOn(formats) {
    if (formats.date.match(/[d]/)) {
      return viewModes.DAYS
    } else if (formats.date.indexOf('M') !== -1) {
      return viewModes.MONTHS
    } else if (formats.date.indexOf('y') !== -1) {
      return viewModes.YEARS
    }
    return viewModes.DAYS
  }

  getFormats(props) {
    let formats = { date: props.dateFormat || '', time: props.timeFormat || '' }
    if (this.getUpdateOn(formats) !== viewModes.DAYS) {
      formats.time = ''
    }
    formats.datetime = formats.date && formats.time ? formats.date + ' ' + formats.time : formats.date || formats.time
    return formats
  }

  componentDidUpdate(prevProps) {
    if (!MC.objectEqual(prevProps, this.props, true)) {
      let nextProps = this.props
      var formats = this.getFormats(nextProps),
        updatedState = {}
      if (nextProps.value !== prevProps.value || formats.datetime !== this.getFormats(prevProps).datetime) {
        updatedState = this.getStateFromProps(nextProps)
      }
      if (nextProps.viewMode !== prevProps.viewMode) {
        updatedState.currentView = nextProps.viewMode
      }
      if (nextProps.utc !== prevProps.utc || nextProps.displayTimeZone !== prevProps.displayTimeZone) {
        if (nextProps.utc) {
          if (this.state.viewDate)
            updatedState.viewDate = this.state.viewDate.toUTC()
          if (this.state.selectedDate) {
            updatedState.selectedDate = this.state.selectedDate.toUTC()
            updatedState.inputValue = updatedState.selectedDate.toFormat(formats.datetime)
          }
        } else if (nextProps.displayTimeZone) {
          if (this.state.viewDate)
            updatedState.viewDate = this.state.viewDate.setZone(nextProps.displayTimeZone)
          if (this.state.selectedDate) {
            updatedState.selectedDate = this.state.selectedDate.setZone(nextProps.displayTimeZone)
            updatedState.inputValue = updatedState.selectedDate.setZone(nextProps.displayTimeZone).toFormat(formats.datetime)
          }
        } else {
          if (this.state.viewDate)
            updatedState.viewDate = this.state.viewDate.toLocal()
          if (this.state.selectedDate) {
            updatedState.selectedDate = this.state.selectedDate.toLocal()
            updatedState.inputValue = updatedState.selectedDate.toFormat(formats.datetime)
          }
        }
      }
      if (nextProps.viewDate !== prevProps.viewDate) {
        updatedState.viewDate = nextProps.viewDate
      }
      this.setState(updatedState)

    }
  }

  onInputChange = (e) => {
    let value = e.target === null ? e : e.target.value
    let localLuxon = this.localLuxon(value, this.state.inputFormat)
    let update = {inputValue: value}
    if (value && localLuxon.isValid && !this.props.value) {
      update.selectedDate = localLuxon
      update.viewDate = localLuxon.startOf('month')
    } else {
      update.selectedDate = null
    }
    return this.setState(update, function () {
      return this.props.onChange(value && localLuxon.isValid ? localLuxon : this.state.inputValue)
    })
  }

  onInputKey = (e) => {
    if (e.which === 9 && this.props.closeOnTab) {
      this.closeCalendar()
    }
  }

  showView = (view) => {
    var me = this
    return function () {
      me.state.currentView !== view && me.props.onViewModeChange(view)
      me.setState({ currentView: view })
    }
  }

  setDate = (type) => {
    let me = this
    let  nextViews = {month: viewModes.DAYS, year: viewModes.MONTHS}
    return function (e) {
      let toSet = {}
      toSet[type] = parseInt(e.target.getAttribute('data-value'), 10)
      me.setState({
        viewDate: me.state.viewDate.set(toSet).startOf(type),
        currentView: nextViews[type]
      })
      me.props.onViewModeChange(nextViews[type])
    }
  }

  subtractTime = (amount, type, toSelected) => {
    let me = this
    return function () {
      me.props.onNavigateBack(amount, type)
      me.updateTime('minus', amount, type, toSelected)
    }
  }

  addTime = (amount, type, toSelected) => {
    let me = this
    return function () {
      me.props.onNavigateForward(amount, type)
      me.updateTime('plus', amount, type, toSelected)
    }
  }

  updateTime = (op, amount, type, toSelected) => {
    let update = {}
    let date = toSelected ? 'selectedDate' : 'viewDate'
    let toSet = {}
    toSet[type] = amount
    update[date] = this.state[date][op](toSet)
    this.setState(update)
  }

  setTime = (type, value) => {
    let index = this.allowedSetTime.indexOf(type) + 1
    let state = this.state
    let date = state.selectedDate || state.viewDate
    let nextType
    // It is needed to set all the time properties
    // to not to reset the time
    let toSet = {}
    toSet[type] = value
    date = date.set(toSet)
    for (; index < this.allowedSetTime.length; index++) {
      nextType = this.allowedSetTime[index]
      toSet = {}
      toSet[nextType] = date.nextType
      date = date.set(toSet)
    }
    if (!this.props.value) {
      this.setState({
        selectedDate: date,
        inputValue: date.toFormat(state.inputFormat)
      })
    }
    this.props.onChange(date)
  }

  updateSelectedDate = (e, close) => {
    let target = e.currentTarget
    let modifier = 0
    let viewDate = this.state.viewDate
    let currentDate = this.state.selectedDate || viewDate
    let date
    if (target.className.indexOf('rdtDay') !== -1) {
      if (target.className.indexOf('rdtNew') !== -1)
        modifier = 1
      else if (target.className.indexOf('rdtOld') !== -1)
        modifier = -1
      date = viewDate.set({month: viewDate.month + modifier, day: parseInt(target.getAttribute('data-value'), 10)})
    } else if (target.className.indexOf('rdtMonth') !== -1) {
      date = viewDate.set({month: parseInt(target.getAttribute('data-value'), 10), day: currentDate.day})
    } else if (target.className.indexOf('rdtYear') !== -1) {
      date = viewDate.set({month: currentDate.month, day: currentDate.day, year: parseInt(target.getAttribute('data-value'), 10)})
    }
    date.set({hour: currentDate.hour, minute: currentDate.minute, second: currentDate.second, millisecond: currentDate.millisecond})
    if (this.props.closeOnSelect && close) {
      this.closeCalendar()
    }
    this.props.onChange(date)
  }

  openCalendar = (e) => {
    if (!this.state.open) {
      this.setState({open: true}, function () {
        this.props.onFocus(e)
      })
    }
  }

  closeCalendar = () => {
    this.setState({open: false}, function () {
      this.props.onBlur(this.state.selectedDate || this.state.inputValue)
    })
  }

  handleClickOutside = (e) => {
    const node = ReactDOM.findDOMNode(this)
    if (node && node.contains(e.target) || (e.target.className && e.target.className.indexOf('rdt') > -1)) {
      return
    }
    if (this.props.input && this.state.open && this.props.open === undefined && !this.props.disableCloseOnClickOutside) {
      this.setState({ open: false }, function () {
        this.props.onBlur(this.state.selectedDate || this.state.inputValue)
      })
    }
  }

  localLuxon = (date, format, props) => {
    props = props || this.props
    let l = null
    if (!date || !date.isLuxonDateTime) {
      if (date) {
        if (props.displayTimeZone) {
          l = DateTime.fromFormat(date, format, { setZone: true })
        } else {
          l = DateTime.fromFormat(date, format)
        }
      } else {
        l = DateTime.local()
      }
    } else {
      l = date
    }
    if (props.locale) {
      l = l.setLocale(props.locale)
    }
    return l
  }

  getComponentProps() {
    let me = this
    let formats = this.getFormats(this.props)
    let props = { dateFormat: formats.date, timeFormat: formats.time }
    this.componentProps.fromProps.forEach(function (name) {
      props[name] = me.props[name]
    })
    this.componentProps.fromState.forEach(function (name) {
      props[name] = me.state[name]
    })
    this.componentProps.fromThis.forEach(function (name) {
      props[name] = me[name]
    })
    return props
  }

  overrideEvent = (handler, action) => {
    if (!this.overridenEvents) {
      this.overridenEvents = {}
    }
    if (!this.overridenEvents[handler]) {
      var me = this
      this.overridenEvents[handler] = function (e) {
        var result
        if (me.props.inputProps && me.props.inputProps[handler]) {
          result = me.props.inputProps[handler](e)
        }
        if (result !== false) {
          action(e)
        }
      }
    }
    return this.overridenEvents[handler]
  }

  isValidDay = (date) => {
    if (this.props.modelerActive) {
      return true;
    }
    let min = this.props.min
    let max = this.props.max
    return MC.isValidDay(date, min, max) ? 1 : 0
  }

  render() {
    let className = 'rdt' + (this.props.className ? (Array.isArray(this.props.className) ? ' ' + this.props.className.join(' ') : ' ' + this.props.className) : '')
    let input = null
    if (this.props.input) {
      var finalInputProps = Object.assign(
        { type: 'text', className: 'form-control', value: this.state.inputValue },
        this.props.inputProps,
        {
          onClick: !this.props.hideCalendar ? this.overrideEvent('onClick', this.openCalendar) : null,
          onFocus: !this.props.hideCalendar ? this.overrideEvent('onFocus', this.openCalendar) : null,
          onChange: this.overrideEvent('onChange', this.onInputChange),
          onKeyDown: this.overrideEvent('onKeyDown', this.onInputKey),
        }
      )
      input = <input key="i" {...finalInputProps}/>
    } else {
      className += ' rdtStatic'
    }
    if (this.props.open || (this.props.open === undefined && this.state.open)) {
      className += ' rdtOpen'
    }
    let CurrentView = this.viewComponents[this.state.currentView]
    return (
      <div className={className}> 
        {input}
        <div key="dt" className="rdtPicker"><CurrentView {...this.getComponentProps()}/></div>
      </div>
    )
  }
  
}

Datetime.defaultProps = {
  className: '',
  defaultValue: '',
  inputProps: {},
  input: true,
  onFocus: function () { },
  onBlur: function () { },
  onChange: function () { },
  onViewModeChange: function () { },
  onNavigateBack: function () { },
  onNavigateForward: function () { },
  timeFormat: true,
  dateFormat: true,
  closeOnSelect: false,
  closeOnTab: true,
  utc: false
}

export default Datetime